import { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";

function JobLocationFormModal({ mode, initialValues, onSubmit, onClose }) {
  const [name, setName] = useState(initialValues?.name || "");
  const [statusId, setStatusId] = useState(
    String(Number(initialValues?.statusId) === 1 ? 1 : 2)
  );
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const isEdit = mode === "edit";

  useEffect(() => {
    setName(initialValues?.name || "");
    setStatusId(String(Number(initialValues?.statusId) === 1 ? 1 : 2));
    setError("");
  }, [initialValues?.name, initialValues?.statusId]);

  async function handleSubmit(event) {
    event.preventDefault();
    const trimmedName = name.trim();
    if (!trimmedName) {
      setError("Job Location name is required.");
      return;
    }
    if (trimmedName.length > 100) {
      setError("Job Location name must be 100 characters or fewer.");
      return;
    }

    setSubmitting(true);
    setError("");
    try {
      await onSubmit({
        name: trimmedName,
        ...(isEdit ? { statusId: Number(statusId) } : {}),
      });
      onClose();
    } catch (submitError) {
      setError(submitError?.message || "Unable to save Job Location.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <Dialog
      open
      onClose={() => {
        if (!submitting) onClose();
      }}
      fullWidth
      maxWidth="sm"
      aria-labelledby="job-location-form-title"
    >
      <form onSubmit={handleSubmit}>
        <DialogTitle id="job-location-form-title">
          {isEdit ? "Edit Job Location" : "Add Job Location"}
        </DialogTitle>
        <DialogContent className="flex flex-col gap-4 pt-2">
          <TextField
            autoFocus
            required
            fullWidth
            label="Job Location Name"
            value={name}
            onChange={(event) => setName(event.target.value)}
            inputProps={{ maxLength: 100 }}
            disabled={submitting}
            error={Boolean(error) && !name.trim()}
          />
          {isEdit ? (
            <TextField
              select
              fullWidth
              label="Status"
              value={statusId}
              onChange={(event) => setStatusId(event.target.value)}
              disabled={submitting}
            >
              <MenuItem value="1">Active</MenuItem>
              <MenuItem value="2">Inactive</MenuItem>
            </TextField>
          ) : null}
          {error ? (
            <div role="alert" className="text-sm text-red-600">
              {error}
            </div>
          ) : null}
        </DialogContent>
        <DialogActions className="px-6 pb-4">
          <Button onClick={onClose} disabled={submitting}>
            Cancel Job Location
          </Button>
          <Button type="submit" variant="contained" disabled={submitting}>
            {submitting
              ? "Saving..."
              : isEdit
                ? "Save Job Location"
                : "Create Job Location"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

export default JobLocationFormModal;
